import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Header from './components/Header';
import Hero from './components/Hero';
import Comparison from './components/Comparison';
import ReportHighlight from './components/ReportHighlight';
import IndustrySolutions from './components/IndustrySolutions';
import DemoVideo from './components/DemoVideo';
import HowTo from './components/HowTo';
import Features from './components/Features';
import Plans from './components/Plans';
import FAQ from './components/FAQ';
import Footer from './components/Footer';
import Contact from './components/Contact';
import LogoCarousel from './components/LogoCarousel';
import TrialSignup from './pages/TrialSignup';
import PrivacyPolicy from './pages/PrivacyPolicy';

function App() {
  const { t, i18n } = useTranslation();
  
  // ページタイトルを言語に応じて設定
  useEffect(() => {
    document.title = t('pageTitle');
  }, [t, i18n.language]);
  
  // URLパラメータでページを切り替え
  const urlParams = new URLSearchParams(window.location.search);
  const page = urlParams.get('page');

  if (page === 'trial-signup') {
    return <TrialSignup />;
  }

  if (page === 'privacy-policy') {
    return <PrivacyPolicy />;
  }

  if (page === 'contact') {
    return (
      <div className="min-h-screen bg-white">
        <Header />
        <main>
          <Contact />
        </main>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white overflow-hidden max-w-screen w-full">
      <Header />
      <main className="overflow-hidden w-full">
        <Hero />
        <LogoCarousel />
        <Comparison />
        <ReportHighlight />
        <IndustrySolutions />
        <DemoVideo />
        <div id="howto">
          <HowTo />
        </div>
        <div id="features">
          <Features />
        </div>
        <div id="plans">
          <Plans />
        </div>
        <div id="faq">
          <FAQ />
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default App;

